import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBrowserWindowOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M0 3c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3zm2 2v12h16V5H2zm8 3 4 5H6l4-5z"
      fill="currentColor"
    />
  </svg>
);
export default SvgBrowserWindowOpen;
